module.exports = __webpack_public_path__ + "static/media/435_Bedroom3.fa063365.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/435_Bedroom3.jpg
// module id = 555
// module chunks = 0